export default {
  isKnownAddress: {
    label: 'Connaissez-vous l\'adresse de livraison ?',
  },
  autocomplete: {
    label: {
      loading: 'Quelle est l\'adresse de chargement ?',
      delivery: 'Quelle est l\'adresse de livraison ?',
    },
    secondaryLabel: {
      loading: 'Confirmez l\'adresse de chargement :',
      delivery: 'Confirmez l\'adresse de livraison :',
    },
    unknownLabel: {
      loading: 'Confirmez l\'adresse de chargement :',
      delivery: 'Indiquez une ville et un code postal éventuels :',
    },
    placeholder: 'Renseignez votre adresse...',
  },
  address: {
    label: 'Adresse décomposée',
    street: {
      label: 'Rue',
    },
    postal: {
      label: 'Code postal *',
    },
    city: {
      label: 'Ville *',
    },
    country: {
      label: 'Pays',
    },
  },
};
